import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductAddToListLinkStyles} from "@insite/content-library/Components/ProductAddToListLink";
import { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import { ProductQuantityBreakPricingStyles} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import GuestProductAddToQuoteButton from "@WhiteCap/Components/GuestRFQ/GuestProductAddToQuoteButton";
import GuestProductQuantityOrdered from "@WhiteCap/Components/GuestRFQ/GuestProductQuantityOrdered";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

// EC-234 : SubTask - EC-282 = Creating a PLP variant for Guest User

interface OwnProps {
    showPrice: boolean;
    showAddToList: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface GuestProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
    addToCartButton?: ButtonPresentationProps;
    quantityOrdered?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    addToListWrapper?: InjectableCss;
}

export const actionsStyles: GuestProductListActionsStyles = {
    wrapper: {
        css: css`
            display: flex;
            width: 100%;
            flex-direction: column;
        `,
    },
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                margin-top: 20px;
            `,
        },
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0;
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            margin-top: 10px;
        `,
    },
    addToCartButton: {
        css: css`
            width: 80%;
            padding: 0 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0 10px;
                    `,
                    css`
                        padding: 0 10px;
                    `,
                    css``,
                    css``,
                    css``,
            ])}
            span{
                font-size: 14px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 12px;
                        `,
                        css`
                            font-size: 12px;
                        `,
                        css``,
                        css``,
                        css``,
                ])}
            }
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin-right: 20px;
                width: 4.1rem;
                min-width: 4.1rem;
                [data-test-selector="product_qtyOrdered-label"] {
                    font-size: 15px;
                    font-weight: 600;
                }
                input[data-test-selector="product_qtyOrdered"] {
                    min-width: 75px;
                }
            `,
        },
    },
    addToListWrapper: {
        css: css`
            margin-top: 20px;
            min-height: 2rem;
        `,
    },
};

const styles = actionsStyles;

const GuestProductListActions: FC<Props> = ({ productContext, productSettings, showPrice, showAddToList }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            {/* {showPrice && (
                <>
                    <ProductPrice
                        product={productContext}
                        showLabel={false}
                        showSavings={true}
                        showSavingsAmount={productSettings.showSavingsAmount}
                        showSavingsPercent={productSettings.showSavingsPercent}
                        extendedStyles={styles.price}
                    />
                    <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
                </>
            )} */}
            <ProductUnitOfMeasureSelect extendedStyles={styles.unitOfMeasureSelect} />
            <StyledWrapper {...styles.addToCartWrapper}>
                <GuestProductQuantityOrdered extendedStyles={styles.quantityOrdered} />
                <GuestProductAddToQuoteButton
                    data-test-selector={`actionsAddToQuote${productContext.product.id}`}
                    extendedStyles={styles.addToCartButton}
                />
            </StyledWrapper>
            {/* {showAddToList && (
                <StyledWrapper {...styles.addToListWrapper}>
                    <ProductAddToListLink
                        data-test-selector={`actionsAddToList${productContext.product.id}`}
                        extendedStyles={styles.addToListLink}
                    />
                </StyledWrapper>
            )} */}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(GuestProductListActions));

// EC-234 : SubTask - EC-282 = Creating a PLP variant for Guest User